import React, { FC } from 'react'

import styled from 'styled-components'

const Root = styled.svg<{ $color: string }>`
  width: 75%;
  height: 75%;
  margin-top: 1px;
  fill: ${(props) => props.$color};
`

interface TickProps {
  color: string
  className?: string
}

export const Tick: FC<TickProps> = ({ color, className }) => {
  return (
    <Root viewBox="0 0 32 32" $color={color} className={className}>
      <path d="M1 14 L5 10 L13 18 L27 4 L31 8 L13 26 z" />
    </Root>
  )
}

export default Tick
